import React from 'react'
import { createRoot } from 'react-dom/client'
import App from '../componentConfigurator/App'

const load = () => {
  const container = document.getElementById('componentConfigurator')
  if (container) {
    const root = createRoot(container)
    root.render(<App />)
  } else {
    console.error('No container found for componentConfigurator')
  }
}

window.addEventListener('DOMContentLoaded', () => {
  load()
})

// Make it working with turbo-drive
document.addEventListener('turbo:load', () => {
  load()
})
